import { ItemList } from '../../orm'

class AdminCallForwardingCostStructureList extends ItemList {
    getEntityKey() {
        return "admin/call_forwarding_cost_structure"
    }
}

export const adminCallForwardingCostStructureList = new AdminCallForwardingCostStructureList("admin_call_forwarding_cost_structure__default")
